/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from "react";
import PopupModules from "src/features/auth/components/PopupModules";
import Products from "../../setting/Products/Products";
import { useSearch } from "src/business-types/grocery/components/SearchContext";

export default function CtrlFOpenPopup(): JSX.Element {
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const previouslyFocusedRef = useRef<HTMLElement | null>(null);
  const { searchTerm, setSearchTerm } = useSearch();

  useMemo(() => {
    if (searchTerm) {
      setOpen(true);
    }
  }, [searchTerm]);

  // Open the modal and remember previous focus
  const openModal = () => {
    previouslyFocusedRef.current = document.activeElement as HTMLElement | null;
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setSearchTerm("");
    // restore focus to previously focused element
    setTimeout(() => {
      previouslyFocusedRef.current?.focus();
    }, 0);
  };

  // Keyboard listener for Ctrl+F / Cmd+F
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      // detect Mac cmd + F as well
      const isFind = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "f";
      if (isFind) {
        e.preventDefault(); // stop the browser's find
        openModal();
      }

      // Close with Escape when open
      if (open && e.key === "Escape") {
        closeModal();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open]);

  // focus the input when modal opens
  useEffect(() => {
    if (open) {
      // small timeout to ensure modal is in DOM
      setTimeout(() => inputRef.current?.focus(), 0);
    }
  }, [open]);

  return (
    <div>
      <PopupModules isOpen={open} onClose={closeModal} title='Find Products' className='w-[70%] h-[70%]'>
        <Products usedPopup={true} />
      </PopupModules>
    </div>
  );
}
